import { useCallback } from "react"
import ClickOutside from "@wayz/react-click-outside"
import { useLocation, useNavigate } from "react-router-dom"
import { useBoolean } from "ahooks"
import classNames from "classnames"
import {
  HeartOutlined,
  PoweroffOutlined as PowerOffOutlined,
  UsergroupAddOutlined as UserGroupAddOutlined,
  UserOutlined,
} from "@ant-design/icons"
import { themes } from "@/constants/constant"
import { CLIENT_URL, UserNameKey } from "@/constants/config"
import { useControllerModel, useUserModel } from "@/models"
import type { FC } from "react"
import "./index.scss"
// ==============================================
interface AvatarProps {
  userName?: string
  // 是否显示退出登录
  isShowLogout?: boolean
  // 是否请求权限
  isRequest?: boolean
  // 是否显示系统配置
  isShowConfig?: boolean
}
const Avatar: FC<AvatarProps> = ({
  userName,
  isShowLogout = true,
  // isRequest = true,
  isShowConfig = true,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  // const { brandId } = useParams<RouterIdsVO>() as any
  const { userInfo } = useUserModel()
  const {
    // isHasOperateAuth,
    theme,
    toggleTheme,
    // setUserAuth
  } = useControllerModel()
  const [visible, { setTrue, setFalse }] = useBoolean(false)

  // 获取公司本人的权限策略概况
  // const { run: userAuthRun } = useRequest(() => getUserAuth(brandId), {
  //   manual: true,
  //   ready: !location.pathname.includes("join"),
  //   onSuccess: (res) => {
  //     // 保存用户权限
  //     setUserAuth(res)
  //   },
  //   onError: () => {
  //     // 保存用户权限
  //     setUserAuth(undefined)
  //   },
  // })

  // 主题颜色
  const themeChange = useCallback(
    (type: string) => {
      if (type === theme) return
      toggleTheme(type)
    },
    [theme, toggleTheme],
  )

  // 跳转页面
  const pageToAuth = () => {
    // 运营端的用户管理页面
    window.open(`${window.location.origin}${CLIENT_URL}`, "_blank")
  }

  // 显隐change
  const avatarVisibleChange = () => {
    const v = !visible
    if (v) {
      setTrue()
    } else {
      setFalse()
    }
  }

  return (
    <ClickOutside onClickOutside={setFalse}>
      <div className="avatar" onClick={avatarVisibleChange}>
        <div
          className={classNames(
            "flex-column",
            "flex-align-center",
            "info-wrapper",
            visible ? "visible" : "hidden",
          )}
        >
          <div className="user info-item flex-1 flex-align-center">
            <UserOutlined className="info-icon" />
            {userName || userInfo?.[UserNameKey]}
          </div>
          {isShowConfig && (
            <div className="info-item">
              <UserGroupAddOutlined className="info-icon" />
              <span className="user-auth" onClick={pageToAuth}>
                系统配置
              </span>
            </div>
          )}
          <div className="info-item">
            <div>
              <HeartOutlined className="info-icon" />
              主题切换
            </div>
            <div className="theme-box">
              {themes.map((item) => (
                <div
                  key={item.value}
                  className={classNames("theme-item", {
                    "theme-item-active": theme === item.value,
                  })}
                >
                  <img src={item.src} onClick={() => themeChange(item.value)} alt="" />
                </div>
              ))}
            </div>
          </div>
          {isShowLogout && (
            <div
              className="logout-btn info-item flex-1 flex-align-center"
              onClick={() => {
                navigate("/passport/logout", {
                  state: { from: location },
                })
              }}
            >
              <PowerOffOutlined className="info-icon" />
              退出登录
            </div>
          )}
        </div>
      </div>
    </ClickOutside>
  )
}

export default Avatar
